<div class="loading">
  <app-spinner color="white"></app-spinner>
  <p *ngIf="showRedirectMessage" class="redirect-message">{{ 'continue.redirecting' | translate }}</p>
</div>
